import '@contentful/live-preview/style.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export const wrapRootElement = ({ element }) => <>{element}</>;
